module.exports = __webpack_public_path__ + "media/images/training-plan_reserve@2x-a2ca40c8b36474999bac652104c4d8ff.jpg";